<template>
    <div class="order-branch-selector">
        <div v-if="showLabel"
             class="order-branch-selector__label">
            {{ l('NAV.ORDER_BRANCH') }}:
        </div>

        <BranchSelector :value="currentBranch"
                        :show-name="showName"
                        :btn-classes="btnClasses"
                        @input="changeBranch" />
    </div>
</template>

<script>
import BranchSelector from '@/vue/components/Branches/BranchSelector';
import { container } from '@/container';
import { mapState } from 'vuex';

export default {
    components: { BranchSelector },

    props: {
        /**
         * Display the branch name on the button (true), or "Select Branch" (false)?
         * This is passed on to the BranchSelector component.
         */
        showName: {
            type: Boolean,
            default: true,
        },

        /**
         * Classes to apply to the main "branch" button that shows the dropdown.
         * This is passed on to the BranchSelector component.
         */
        btnClasses: {
            type: String,
            default: 'btn btn-default btn-lg mr-0',
        },

        /**
         * Add some text next to the dropdown to show what the dropdown is for?
         */
        showLabel: {
            default: false,
            type: Boolean,
        },
    },

    computed: {
        ...mapState(['currentBranch']),
    },

    methods: {
        /**
         * @param {Branch} newBranch
         */
        changeBranch(newBranch) {
            let oldBranch = container.userService.currentBranch;

            console.log(
                'Changing branch',
                {
                    oldBranchID: oldBranch ? oldBranch.ID : null,
                    newBranchID: newBranch ? newBranch.ID : null,
                },
            );

            // Set the new order branch, and change the item branch when we do this too.
            container.userService.changeBranches(newBranch, newBranch);
        },
    },
};
</script>

<style lang="less">
@import "../../../less/variables";

.order-branch-selector {
    display: flex;
    grid-gap: @gutter-width;

    &__label {
        flex-grow: 0;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: bold;
        font-size: 15px;
    }

    .branch-selector {
        flex-grow: 1;
        flex-shrink: 1;
    }
}
</style>
